<div class="schema-dm">
  @if (!renderInsideModernizeMenu) {
    <div class="schema-header">
      <div class="d-flex">
        <div class="label" [ngClass]="{ 'color-blue': aiGenerationType !== 2 }">
          {{
            (aiGenerationType === 2 ? 'SQL_TO_DATA_MODEL_MODAL_TITLE_FIELD' : 'SQL_TO_DATA_MODEL_MODAL_TITLE')
              | translate
          }}<span class="sub-label" *ngIf="aiGenerationType === 2">
            - {{ metaInfoMap[this.config.data?.tableId] }}</span
          >
        </div>
        <div class="ml-2 api-status" *ngIf="appGlobalService?.apiStatusJson?.updateFlag && !triggerImport">
          <span
            *ngIf="appGlobalService?.apiStatusJson?.updateFlag"
            class="badge {{ appGlobalService?.apiStatusJson?.class }} {{
              appGlobalService?.apiStatusJson?.updateFlagContent
            }}"
          >
            {{ appGlobalService.apiStatusJson.updateFlagContent }}
          </span>
        </div>
      </div>
      <div class="actions">
        <button class="visualizer-btn d-flex align-items-center" *ngIf="showLogs" (click)="openErrPopup()">
          <i class="pi pi-file"></i>
          <span>{{ 'LOGS' | translate }}</span>
        </button>
        <button
          class="visualizer-btn"
          *ngIf="!aiDataModelGenerationInprogress && dataModelDataOrder.length && !isVisualizerVisible"
          (click)="showVisualizer()"
        >
          <svg-icon src="assets\images\svg\icon_visualizer.svg"></svg-icon>
          <span>{{ 'SHOW_VISUALIZER' | translate }}</span>
        </button>
        <button
          class="show-tree-view-btn"
          *ngIf="!aiDataModelGenerationInprogress && dataModelDataOrder.length && isVisualizerVisible"
          (click)="hideVisualizer()"
        >
          <svg-icon src="assets\images\svg\tree-list.svg"></svg-icon>
          <span>{{ 'SHOW_TREE_VIEW' | translate }}</span>
        </button>
        <div class="upload-schema" *ngIf="!aiDataModelGenerationInprogress && aiGenerationType !== 2">
          <p-button
            type="button"
            class="visualizer-btn"
            pRipple
            icon="pi pi-upload"
            label="{{ 'UPLOAD' | translate }}"
            (onClick)="menu.toggle($event)"
          />
          <p-menu
            [styleClass]="'geni-ai-import-menu'"
            #menu
            appendTo="body"
            [popup]="true"
            [model]="menuItems"
          ></p-menu>
        </div>
        <div class="upload-schema" *ngIf="!aiDataModelGenerationInprogress && aiGenerationType !== 2">
          <p-button
            type="button"
            class="visualizer-btn"
            pRipple
            icon="pi pi-comment"
            label="{{ 'PROMPT' | translate }}"
            (onClick)="togglePromptSection()"
          />
        </div>
        <div class="retry-schema" *ngIf="!aiDataModelGenerationInprogress && aiGenerationType === 2">
          <p-button
            type="button"
            class="visualizer-btn"
            pRipple
            icon="pi pi-refresh"
            label="{{ 'RETRY' | translate }}"
            (onClick)="regenerateFieldsSchema()"
          />
        </div>
        <span (click)="closeDialog()" tabindex="0" (keyup.enter)="closeDialog()" aria-label="Close dialog">
          <i class="pi pi-times-circle close-icon"></i>
        </span>
      </div>
    </div>
  }
  <div class="schema-body">
    <div
      class="ai-datamodel-container"
      [ngClass]="{
        'd-none': isVisualizerVisible,
        'd-block': !isVisualizerVisible,
        'h-60': isPromptSectionVisible,
        'opacity-50-percent': aiDataModelGenerationInprogress
      }"
    >
      <div class="main-card data-model ai-data-model mb-3 card sample-data">
        <div class="card-body">
          <div class="container-fluid">
            <p-splitter
              [panelSizes]="panelSizes"
              [minSizes]="[30, 70]"
              [style]="{ height: '100%' }"
              stateKey="dmSplitterKey"
              stateStorage="local"
              #schemaSplitter
              class="dm-splitter"
            >
              <ng-template pTemplate>
                <div class="tree-container w-100">
                  <div class="table-header">
                    <div class="header d-flex">{{ 'TABLES' | translate }}</div>
                    <div class="btn-container">
                      <div class="formgroup-inline searchbox-button">
                        <div class="field">
                          <div class="p-inputgroup">
                            <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                            <input
                              type="text"
                              class="p-inputtext p-component p-element"
                              placeholder="Search"
                              aria-describedby="basic-addon1"
                              [(ngModel)]="searchTerm"
                              [ngModelOptions]="{ standalone: true }"
                              (search)="filterTreeContent($event)"
                              (keyup)="filterTreeContent($event)"
                            />
                            <span
                              class="p-inputgroup-addon"
                              *ngIf="searchTerm !== '' && searchTerm !== undefined && searchTerm !== null"
                              (click)="clearFilter()"
                              (keyup.enter)="clearFilter()"
                              tabindex="1"
                              ><i class="pi pi-times"></i
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <table id="schemaTree" class="mr-0">
                    <colgroup>
                      <col width="0px;" />
                      <col width="65%" />
                      <col width="30%" />
                      <col width="5%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td></td>
                        <td></td>
                        <td class="field-type">
                          <div class="dropdown dataTypes">
                            <button
                              class="btn dropdown-toggle toggle-button hidden"
                              type="button"
                              [disabled]="disallowEdit"
                              id="data-field-type"
                            >
                              {{ 'STRING' | translate }}
                            </button>
                          </div>
                        </td>
                        <td class="context-menu-td">
                          <div class="dropdown contextMenu">
                            <p-button
                              class="btn dropdown-toggle toggle-button hidden"
                              icon="pi pi-ellipsis-v"
                              type="button"
                              [disabled]="disallowEdit"
                              id="context-menu-trigger"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </ng-template>
              <ng-template pTemplate>
                <div class="w-100 d-flex flex-direction-column">
                  <div *ngIf="propertyLoading" class="loading-model property">
                    <p-progress-spinner></p-progress-spinner>
                  </div>
                  <vb-schema-properties-pane
                    [style]="{ width: '100%' }"
                    *ngIf="showPropPane"
                    [availableTables]="availableTables"
                    [tableData]="propertyPaneData"
                    [fieldIdMap]="tableFieldMap"
                    [tableMap]="tableMap"
                    [selectedNodeType]="selectedNodeType"
                    [uploadId]="uploadId"
                    [tabId]="tabId"
                    [selectedPropertyTitle]="selectedNodeTitle"
                    [disallowEdit]="renderInsideModernizeMenu ? (disallowEdit ? true : isStepReadOnly) : disallowEdit"
                    [isGenerationWizard]="renderInsideModernizeMenu"
                    (requestParentTableUpdate)="onRequestParentTableUpdate($event)"
                    [tableAndFieldDataMap]="tableAndFieldDataMap"
                    [workflowAssociated]="workflowAssociated"
                    class="properties-pane"
                  >
                  </vb-schema-properties-pane>
                  <div *ngIf="dataModelDataOrder.length && !selectedNodeTitle" class="no-prop-text mt-1">
                    Please click on the row to see the properties.
                  </div>
                </div>
              </ng-template>
            </p-splitter>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="isPromptSectionVisible"
      class="ai-prompt-container"
      [ngClass]="isVisualizerVisible ? 'd-none' : 'd-block'"
    >
      <div class="prompt-header">
        <div>
          <span class="heading">{{ 'PROMPT_HEADING' | translate }}</span>
          <i
            class="fa fa-info-circle prompt-field-info"
            showDelay="100"
            hideDelay="100"
            tooltipPosition="bottom"
            tooltipStyleClass="label-tooltip custom-tooltip-properties"
            pTooltip="{{ 'PROMPT_INFO_BUBBLE_TEXT' | translate }}"
          >
          </i>
        </div>
      </div>
      <div class="prompt-body">
        <textarea
          class="promt-textarea"
          pTextarea
          [(ngModel)]="promptText"
          placeholder="Start typing the prompt here..."
        ></textarea>
        <p-button
          type="button"
          icon="pi pi-send"
          class="p-button-rounded prompt-submit-btn"
          (onClick)="generateModelForTablePrompt()"
          [disabled]="!promptText?.trim()?.length"
        />
      </div>
    </div>
    <div class="visualizer-container" *ngIf="isVisualizerVisible">
      <vb-data-model-visualizer
        [dataModelDataOrder]="dataModelDataOrder"
        [referredTableData]="[]"
        [tablesInfo]="dataModelDataOrder"
        [tableMap]="tableMap"
        [refAppMetaInfos]="[]"
        [fkDeats]="{}"
        [tableFieldMap]="tableFieldMap"
        [complexTables]="[]"
        [fullScreen]="false"
      ></vb-data-model-visualizer>
    </div>
    <div class="spinner-container" *ngIf="isLoading">
      <p-progress-spinner></p-progress-spinner>
    </div>
    <vb-blocker
      [blocked]="true"
      [blockerType]="
        aiGenerationType === 0
          ? 'GEN_AI_IMPORT'
          : aiGenerationType === 1
            ? 'GEN_AI_PRMOPT_GENERATION'
            : 'GEN_AI_FIELD_GENERATION'
      "
      [importStatus]="
        aiGenerationType === 0
          ? importStatus
          : importStatus === 'API_DATA_MODELLER_SERVICE_CALL'
            ? 'ANALYSING_GEN_AI_SERVICE_RESPONSE'
            : importStatus
      "
      [importPercent]="uploadProgress"
      [isDisplayed]="aiDataModelGenerationInprogress && !isImportDialogVisible"
    ></vb-blocker>
  </div>
  @if (!renderInsideModernizeMenu) {
    <div class="footer">
      <p-button pRipple label="{{ 'CLOSE' | translate }}" class="close-btn" (onClick)="closeDialog()" />
      <p-button
        pRipple
        label="{{ 'GEN_AI_REJECT_DATA_MODEL' | translate }}"
        class="reject-btn"
        (onClick)="rejectDataModel()"
        [disabled]="!isDataModelReadyToMerge || !this.dataModelDataOrder.length || disallowEdit"
      />
      <p-button
        pRipple
        label="{{ 'GEN_AI_ACCEPT_DATA_MODEL' | translate }}"
        class="accept-btn"
        (onClick)="acceptDataModel()"
        [disabled]="!isDataModelReadyToMerge || !this.dataModelDataOrder.length || disallowEdit"
      />
    </div>
  }
</div>

<p-popover #dataTypeOp styleClass="datamodel-data-type" (onHide)="clearFilterData()">
  <ng-template #content>
    <div class="data-field-type searchbox-button">
      <div class="field">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
          <input
            [(ngModel)]="filter"
            name="filter"
            [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
            class=""
            id="filter"
            placeholder="Search"
            autocomplete="off"
          />
          <span class="p-inputgroup-addon us-input-clear-icon d-none" id="btnResetSearch"
            ><i class="pi pi-times"></i
          ></span>
        </div>
      </div>
    </div>
    <div class="data-type-items">
      <ng-container *ngFor="let type of dataTypes | uiFilter: filter : ['name']">
        <ng-container *ngIf="type.isDivider; then divider; else filterOrData"></ng-container>
        <ng-template #divider>
          <div [class]="type.class" class="dropdown-divider"></div>
        </ng-template>
        <ng-template #filterOrData>
          <ng-container *ngIf="type.isFilter; then filter; else data"></ng-container>
        </ng-template>
        <ng-template #data>
          <span
            [attr.value]="type.value"
            [class]="type.class"
            *ngIf="(hideDts && type.name !== 'File Attachment' && type.name !== 'Image Carousel') || !hideDts"
            class="dropdown-item"
            (click)="setDataType(type.value)"
            (keyup.enter)="setDataType(type.value)"
            tabindex="2"
            >{{ type.name }}</span
          >
        </ng-template>
      </ng-container>
    </div>
  </ng-template>
</p-popover>

<p-dialog
  [(visible)]="isImportDialogVisible"
  styleClass="cloud"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [closable]="false"
  [style]="{ width: '50vw' }"
  styleClass="publish-status-model gen-ai-upload-dialog"
>
  <ng-template #header>
    <div class="d-flex flex-prototype import-title">
      {{ importDialogHeader | translate }}
    </div>
    <div class="close-dialog">
      <span (click)="closeImportDialog()" (keyup.enter)="closeImportDialog()" tabindex="3">
        <i
          class="pi pi-times-circle close-icon"
          style="font-size: 1.2rem !important; position: absolute; right: 15px; top: 15px; cursor: pointer"
        ></i
      ></span>
    </div>
  </ng-template>
  <div class="d-flex justify-content-center flex-column mt-2">
    <!-- 5mb = 5242880bytes -->
    <!-- Changing the maxfilesize needs change in invalidFileSizeMessageDetail too. -->
    <p-fileUpload
      #fileupload
      name="myfile"
      url="./upload.php"
      (onSelect)="onSelectImage($event)"
      [showUploadButton]="false"
      [accept]="acceptedFileTypes"
      maxFileSize="5242880"
      [showCancelButton]="false"
      [disabled]="disallowEdit"
      *ngIf="!myfile.length"
      [invalidFileSizeMessageSummary]="'{0}: Invalid file size, '"
      [invalidFileSizeMessageDetail]="'maximum upload size is 5mb.'"
    >
      <ng-template pTemplate="header" styleClass="d-none p-0 border-0" style></ng-template>
      <ng-template pTemplate="content" let-files>
        <div class="upload-area">
          <svg-icon src="assets\images\svg\file-upload.svg"></svg-icon>
          <p class="mb-2">
            <u (click)="fileupload.choose()" style="cursor: pointer" (keyup.enter)="fileupload.choose()" tabindex="4">{{
              'IMPORT_DIALOG_CLICK_TXT' | translate
            }}</u>
            {{ 'IMPORT_DIALOG_DROP_TXT' | translate }}
          </p>
          <small>{{ ('IMPORT_DIALOG_SUB_TXT' | translate).replace('{fileTypes}', acceptedFileTypes) }}</small>
        </div>
      </ng-template>
    </p-fileUpload>
    <div class="selected-files" *ngIf="myfile.length">
      <div *ngFor="let file of myfile; let i = index" class="selected-file">
        <div class="icon">
          <i class="pi pi-file"></i>
        </div>
        <div class="file-content">
          <span showDelay="100" hideDelay="100" tooltipPosition="top"
            tooltipStyleClass="label-tooltip custom-tooltip-properties" pTooltip="{{ file?.name }}">{{ file.name
            }}</span>
          <br />
          {{ formatBytes(file?.size) }}
        </div>
        <div class="clear">
          <i class="pi pi-times" (click)="removeFile(i)" (keyup.enter)="removeFile(i)" tabindex="5"></i>
        </div>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <div class="text-right update-form">
      <button type="button" class="btn btn-primary cancel-btn" (click)="closeImportDialog()">
        {{ 'IMPORT_DIALOG_CANCEL_CLOSE_BTN' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-primary generate-btn"
        [disabled]="!myfile?.length"
        (click)="generateSchema()"
      >
        {{ 'GENERATE_DATA_MODEL' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="errPopup"
  styleClass="cloud"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  closable="errPopup"
  [style]="{ width: '50vw' }"
  styleClass="publish-status-model"
>
  <ng-template #header>
    <div class="d-flex flex-prototype">
      {{ 'AI_LOG_HEADER' | translate }}
    </div>
  </ng-template>
  <div class="d-flex justify-content-center flex-column mt-2">
    <ng-container *ngIf="this.lastestUploadData?.generateDatamodelErrorMsg">
      <div class="list-err mb-2" *ngFor="let err of this.lastestUploadData.generateDatamodelErrorMsg; let i = index">
        <span class="mr-1">{{ i + 1 }}.</span>
        <span>{{ err }}</span>
      </div>
    </ng-container>
    <p class="mb-2" *ngIf="this.lastestUploadData?.generateDatamodelErrorMsg?.length > 1">
      {{ 'CONFIRMATION_ON_ERROR' | translate }}
    </p>
  </div>
  <ng-template #footer>
    <div class="text-right update-form">
      <button type="button" class="btn btn-primary cancel-btn" (click)="closeErrPopup()">
        {{ 'CLOSE' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog key="acceptAiSuggesstionConfirmation">
  <ng-template pTemplate="message" let-message>
    <div>
      <div class="mt-2">
        <span>{{ message.message }}</span>
      </div>

      <div class="d-flex align-items-center mt-2" *ngIf="pageGenRequired">
        <p-checkbox class="mr-2" [(ngModel)]="allowCreationOfPages" [binary]="true" id="confirmCheckbox" />
        <label class="mb-0" for="confirmCheckbox">{{ 'GEN_AI_CREATE_PAGES_CONF_MSG' | translate}}</label>
      </div>
    </div>
  </ng-template>
</p-confirmDialog>